import { RootState } from '../store';
import { IPagination } from './paginationTypes';

const selectPaginationData = (state: RootState): IPagination => state.pagination.paginationData;

export const paginationSelectors = {
  selectPaginationData,
};
